import { HttpMethod } from '../../http-method'
import { OrderLineReferenceSettings } from './models'

export const getOrderLineReferenceSettings = () => ({
  method: HttpMethod.GET,
  url: `/modules/order-line-reference/settings`
})

export const putOrderLineReferenceSettings = (newValues: OrderLineReferenceSettings) => ({
  method: HttpMethod.PUT,
  url: `/modules/order-line-reference/settings`,
  data: newValues
})
